// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"pdfjsWorker","768":"App"}[chunkId] || chunkId) + "." + {"94":"a2812011","763":"bda97392","768":"c7ac9b16"}[chunkId] + ".chunk.js";
};